import styled from "styled-components";
import theme from "../../Styles/theme";

export const Button = styled.button`

    color: ${theme.colors.light};
    background-color: ${theme.colors.darkGrey};
    &:hover {
        opacity: 0.8;
    }


    width:100%;

    padding:2vh 1vw;

    border-radius: 0.25rem;

`;